// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var OptionUtils = require("./OptionUtils.bs.js");

function confirm(onCancel, message, f) {
  if (window.confirm(message)) {
    return Curry._1(f, undefined);
  } else {
    return OptionUtils.mapWithDefault((function (onCancel) {
                  return Curry._1(onCancel, undefined);
                }), undefined, onCancel);
  }
}

exports.confirm = confirm;
/* No side effect */
